import * as React from 'react';

const ClickAndReserveContextDefaultValues = {
    activeStep: 0,
    setActiveStep: ()=>null
    ,
    selectedStore: undefined,
    setSelectedStore: ()=>null
    ,
    searchLocation: undefined,
    setSearchLocation: ()=>null
    ,
    user: undefined,
    setUser: ()=>null
    ,
    customerDetailsFormState: {
        current: undefined
    },
    onChangeCustomerDetails: ()=>null
    ,
    customerDetailsPrefilled: {
        current: false
    },
    isAuthLoading: true,
    reservationNumber: undefined,
    setReservationNumber: ()=>null
    ,
    preferredChannelOfCommunication: undefined,
    setPreferredChannelOfCommunication: ()=>null
};
const ClickAndReserveContext = /*#__PURE__*/ React.createContext(ClickAndReserveContextDefaultValues);
const useClickAndReserveContext = ()=>React.useContext(ClickAndReserveContext)
;

export { ClickAndReserveContext, ClickAndReserveContextDefaultValues, useClickAndReserveContext };
//# sourceMappingURL=ClickAndReserveContext.js.map
